import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { ReportTheme } from '../../types';
import { getChartColor } from './chartUtils';

interface OrganicClicksLineChartWidgetProps {
  data: any;
  data_points?: string[];
  report_start_date?: string;
  report_end_date?: string;
  reportTheme: ReportTheme;
}

export const OrganicClicksLineChartWidget: React.FC<OrganicClicksLineChartWidgetProps> = ({ 
  data, 
  data_points,
  report_start_date,
  report_end_date,
  reportTheme 
}) => {
  console.log('OrganicClicksLineChartWidget raw data:', data);

  // Process the raw API data internally for Organic Clicks
  const processData = () => {
    if (!data || !data.data || typeof data.data !== 'object') {
      console.warn('OrganicClicksLineChartWidget: Invalid data structure');
      return null;
    }

    const rawData = data.data;
    const entries = Object.entries(rawData);
    
    if (entries.length === 0) {
      console.warn('OrganicClicksLineChartWidget: No data entries found');
      return null;
    }

    const firstEntry = entries[0];
    const [, firstDayData] = firstEntry;
    
    if (!firstDayData || typeof firstDayData !== 'object' || !(firstDayData as any).date) {
      console.warn('OrganicClicksLineChartWidget: Invalid data format');
      return null;
    }

    if (typeof (firstDayData as any).clicks !== 'number') {
      console.warn('OrganicClicksLineChartWidget: Missing required metric (clicks)');
      return null;
    }
    
    const chartData = entries.map(([dateKey, dayData]: [string, any]) => {
      if (!dayData || typeof dayData !== 'object' || !dayData.date) {
        return null;
      }

      return {
        name: new Date(dayData.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
        clicks: dayData.clicks || 0
      };
    }).filter((item): item is { name: string; clicks: number } => item !== null)
      .sort((a, b) => new Date(a.name).getTime() - new Date(b.name).getTime());

    return chartData.length > 0 ? chartData : null;
  };

  const processedData = processData();

  if (!processedData || processedData.length === 0) {
    return null;
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={processedData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Line 
          type="monotone" 
          dataKey="clicks" 
          stroke={getChartColor(0, reportTheme.theme)} 
          strokeWidth={2} 
          name="Organic Clicks"
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
